export default __webpack_public_path__ + "static/media/factor_item_2.9fcf7ed3.png";